<div class="content space-y-4">
    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faBoxOpen" class="text-primary-500 text-xl"></fa-icon>
            <span>คำสั่งซื้อ</span>
            <span class="label label-primary !text-xs">สาขา</span>
        </div>
    </div>

    <div class="card">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div class="w-full">
                <label class="text-sm">สาขา</label>
                <div class="relative w-full">
                    <input type="text" class="input" placeholder="ค้นหาสาขา"
                        [(ngModel)]="branchKeyword" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="filterBranches()" (focus)="openBranchFilter()"
                        (blur)="closeBranchFilter()">
                    <ul class="absolute z-50 w-full !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2"
                        *ngIf="showBranchFilter && branchesFilter.length > 0">
                        <li *ngFor="let branch of branchesFilter"
                            class="min-h-[40px] hover:bg-secondary-100 hover:cursor-pointer flex items-center px-3 py-2 text-sm"
                            [ngClass]="{'bg-primary-50 font-semibold': branch.shop_ref === channelSelected}"
                            (mousedown)="selectBranch(branch)">
                            <span class="inline-block w-2 h-2 rounded-full mr-2 shrink-0"
                                [style.background-color]="branch.color || '#32436a'"></span>
                            <span class="truncate">{{branch.platform_name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="text-xs text-gray-500 mt-3">
            ออเดอร์ที่ยังไม่ได้แพ็ก · ระบบจะจองสินค้าไว้ทำให้ ข้อมูลสต๊อก Sabuysoft ไม่ตรงกับ แพลตฟอร์ม
        </div>
    </div>

    @if (loading) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    } @else if (errorMessage) {
    <div class="card">
        <div class="text-sm text-red-500 py-4 text-center">{{ errorMessage }}</div>
    </div>
    } @else if (orders.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium text-gray-600">ไม่มี order ที่ยังไม่ได้แพ็ก</div>
        </div>
    </div>
    } @else {
    <div class="space-y-3">
        @for (order of orders; track $index) {
        <div class="rounded-lg border border-gray-200 overflow-hidden bg-white shadow-sm">
            <div class="bg-gradient-to-r from-primary-50 to-white px-4 py-2.5 flex items-center gap-3 border-b border-gray-200">
                <div class="flex items-center gap-2 min-w-0 flex-wrap">
                    <span class="text-xs text-gray-500 uppercase tracking-wider">Order</span>
                    <span class="font-mono text-sm font-semibold text-primary-600 truncate">{{ order.order_platform }}</span>
                    @if (order.create_at) {
                    <span class="text-gray-300">·</span>
                    <span class="text-xs text-gray-500">{{ order.create_at }}</span>
                    }
                </div>
                <div class="ml-auto flex items-center gap-1 text-xs text-gray-500 shrink-0">
                    <span class="inline-flex items-center justify-center min-w-[1.5rem] h-5 px-1.5 rounded-full bg-primary-100 text-primary-700 font-semibold">
                        {{ order.items.length | number }}
                    </span>
                    <span>รายการ</span>
                </div>
            </div>

            @if (order.items.length === 0) {
            <div class="px-4 py-3 text-sm text-gray-400 italic">ไม่มีข้อมูลสินค้า</div>
            } @else {
            <ul class="divide-y divide-gray-100">
                @for (item of order.items; track $index) {
                <li class="px-4 py-3 flex items-start gap-4 hover:bg-gray-50 transition-colors">
                    <img [src]="'https://storage.maxxgadget.com/img/product/' + item.seller_sku + '/1.jpg'"
                        alt="" class="flex-none w-12 h-12 rounded object-cover bg-gray-50"
                        onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                    <div class="flex-1 min-w-0">
                        <div class="font-medium text-gray-900 break-words leading-snug">
                            {{ item.product_name || '-' }}
                        </div>
                        @if (item.model_name) {
                        <div class="text-xs text-gray-500 mt-0.5 break-words">{{ item.model_name }}</div>
                        }
                        @if (item.seller_sku) {
                        <div class="inline-flex items-center gap-1 mt-1.5 px-2 py-0.5 rounded text-xs font-mono bg-blue-50 text-blue-600">
                            {{ item.seller_sku }}
                        </div>
                        }
                    </div>
                    <div class="flex flex-col items-end shrink-0">
                        <span class="text-xs text-gray-400">จำนวน</span>
                        <span class="text-lg font-bold text-primary-600 leading-none mt-0.5">×{{ item.qty | number }}</span>
                    </div>
                </li>
                }
            </ul>
            }
        </div>
        }
        <div class="text-sm text-gray-600 px-1">
            ทั้งหมด <span class="font-semibold text-primary-600">{{ orders.length | number }}</span> orders
        </div>
    </div>
    }
</div>
